// extracted by mini-css-extract-plugin
module.exports = {"carousel":"UiCarousel_carousel__3N1Xs","arrow":"UiCarousel_arrow__29JpX","right":"UiCarousel_right__1f5a0","left":"UiCarousel_left__LFo52"};